import React, { FC } from 'react'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import { Form, Collapse, Row, Col } from 'antd'
import { useTranslation } from 'react-i18next'
import { debounce } from 'lodash'
import { useSelector } from 'react-redux'
import { RootState } from '../../../reducers'

// atoms
import InputField from '../../../atoms/InputField'
import ColorPickerField from '../../../atoms/ColorPickerField'

// interfaces
import { IFormItemData } from '../../../types/interfaces'

// utils
import { ELEMENT_ATTRIBUTES, FORM, PROTECTION_INTERVAL_FOR_SAVING_ELEMENT } from '../../../utils/enums'

// assets
import { ReactComponent as ChevronIcon } from '../../../assets/icons/BaseIcons/chevron-down-1-icon.svg'
import { ReactComponent as HeightIcon } from '../../../assets/icons/BaseMiniIcons/height-icon.svg'
import { ReactComponent as WidthIcon } from '../../../assets/icons/BaseMiniIcons/width-icon.svg'
import { ReactComponent as TrashIcon } from '../../../assets/icons/BaseIcons/trash-1-icon.svg'

const { Panel } = Collapse

export type ComponentProps = {
	onRemoveItem: Function
}
type Props = InjectedFormProps<IFormItemData, ComponentProps> &
	ComponentProps & {
		handleSubmit: Function
	}

const HorizontalLineElementForm: FC<Props> = (props) => {
	const { t } = useTranslation()
	const { handleSubmit, onRemoveItem } = props
	const disable = useSelector((state: RootState) => state.formTemplate.disable)
	const formItemId = useSelector((state: RootState) => state.form?.[FORM.HORIZONTAL_LINE_ELEMENT_FORM]?.values?.i)

	return (
		<Form layout={'vertical'} onSubmitCapture={handleSubmit}>
			<Row className={'mx-4 mb-4'} justify={'space-between'}>
				<h3>{t('loc:Horizontal line')}</h3>
				<TrashIcon className={'trashIcon'} onClick={() => onRemoveItem(formItemId)} />
			</Row>
			<Collapse expandIcon={({ isActive }) => <ChevronIcon rotate={isActive ? 0 : 180} />} expandIconPosition={'end'} ghost>
				<Panel header={t('loc:Size')} key='1'>
					<Row justify={'center'} className={'my-2 w-full'}>
						<Col span={11}>
							<Field
								className={'element-width'}
								component={InputField}
								name={ELEMENT_ATTRIBUTES.COL}
								size={'medium'}
								suffix={<WidthIcon />}
								disabled={disable}
								maxLength={2}
							/>
						</Col>
						<Col span={2} />
						<Col span={11}>
							<Field
								className={'element-height'}
								component={InputField}
								name={ELEMENT_ATTRIBUTES.ROW}
								size={'medium'}
								suffix={<HeightIcon />}
								disabled={true}
							/>
						</Col>
					</Row>
				</Panel>
			</Collapse>
			<Row className={'py-2 px-4 last-item'} justify={'center'}>
				<Col className={'h-34px flex flex-col justify-center'} span={11}>
					<p className={'m-0'}>{t('loc:Color')}</p>
				</Col>
				<Col span={2} />
				<Col className={'h-34px'} span={11}>
					<Field component={ColorPickerField} name={ELEMENT_ATTRIBUTES.LABEL_COLOR} size={'medium'} disabled={disable} />
				</Col>
			</Row>
		</Form>
	)
}

const form = reduxForm<IFormItemData, ComponentProps>({
	form: FORM.HORIZONTAL_LINE_ELEMENT_FORM,
	forceUnregisterOnUnmount: true,
	touchOnChange: true,
	destroyOnUnmount: true,
	onChange: debounce((values, dispatch, props) => {
		if (props.anyTouched) {
			props.submit()
		}
	}, PROTECTION_INTERVAL_FOR_SAVING_ELEMENT)
})(HorizontalLineElementForm)

export default form
